<div class="acciones no-print">
  <button class="btn btn-outline-secondary" type="button" (click)="volver()">Volver</button>
  <button *ngIf="ficha" class="btn fondoAmarillo blanco bold" type="button" (click)="imprimir()">Imprimir ficha</button>
</div>

<div *ngIf="cargando" class="estado">Preparando ficha de pago…</div>
<div *ngIf="error" class="alert alert-danger estado">{{error}}</div>

<main *ngIf="ficha" class="ficha">
  <header class="ficha-header">
    <img src="assets/img/auri.png" alt="Auri Graduaciones" class="auri-logo">
    <img src="assets/img/Paynet/logos-paynet-02.png" alt="Paynet" class="paynet-logo">
  </header>

  <section class="titulo">
    <h1>Ficha de pago en efectivo</h1>
    <p>Presenta esta ficha para realizar tu pago.</p>
  </section>

  <section class="datos-pago">
    <div>
      <span>Monto a pagar</span>
      <strong>{{ficha.amount | currency:ficha.currency:'symbol':'1.2-2'}}</strong>
    </div>
    <div>
      <span>Referencia</span>
      <strong class="referencia">{{ficha.reference}}</strong>
    </div>
    <div *ngIf="ficha.due_date">
      <span>Fecha límite de pago</span>
      <strong>{{ficha.due_date | date:'dd/MM/yyyy'}}</strong>
    </div>
  </section>

  <section class="codigo-barras">
    <img [src]="ficha.barcode_url" alt="Código de barras para pago en efectivo">
    <small>{{ficha.reference}}</small>
  </section>

  <section class="instrucciones">
    <h2>Instrucciones</h2>
    <ol>
      <li>Acude a 7-Eleven, Walmart, Farmacias del Ahorro, Farmacias Benavides, Sam's Club o Bodega Aurrera.</li>
      <li>Indica en caja que realizarás un pago de servicio y presenta esta ficha.</li>
      <li>Presenta el código de barras o proporciona la referencia de esta ficha.</li>
      <li>Realiza el pago por el monto exacto indicado y conserva tu comprobante.</li>
    </ol>
    <p>El pago puede tardar algunos minutos en verse reflejado. El establecimiento puede cobrar una comisión adicional.</p>
  </section>

  <section class="establecimientos">
    <h2>Establecimientos participantes</h2>
    <div class="establecimientos-grid">
      <img src="assets/img/Paynet/7eleven.jpg" alt="7-Eleven">
      <img src="assets/img/Paynet/Eleczion.png" alt="Eleczion">
      <img src="assets/img/Paynet/Kiosko.png" alt="Kiosko">
      <img src="assets/img/Paynet/LogoSorianaFondoBlancoRGB%20(1).jpg" alt="Soriana">
      <img src="assets/img/Paynet/MásBodega.png" alt="Más Bodega">
      <img src="assets/img/Paynet/Mercadía.png" alt="Mercadía">
      <img src="assets/img/Paynet/Pagaqui-Logo.png" alt="Pagaquí">
      <img src="assets/img/Paynet/Sam_s%20Club.png" alt="Sam's Club">
      <img src="assets/img/Paynet/VIA-Servicios.png" alt="Vía Servicios">
      <img src="assets/img/Paynet/bodegaAurrera.jpg" alt="Bodega Aurrera">
      <img src="assets/img/Paynet/circlek.jpg" alt="Circle K">
      <img src="assets/img/Paynet/extra.jpg" alt="Extra">
      <img src="assets/img/Paynet/farmaciaAhorro.jpg" alt="Farmacias del Ahorro">
      <img src="assets/img/Paynet/farmaciaGuadalajara.jpg" alt="Farmacias Guadalajara">
      <img src="assets/img/Paynet/systienda.png" alt="Systienda">
      <img src="assets/img/Paynet/tiendas-k.jpg" alt="Tiendas K">
      <img src="assets/img/Paynet/waldos.jpg" alt="Waldo's">
      <img src="assets/img/Paynet/walmart.jpg" alt="Walmart">
      <img src="assets/img/Paynet/walmart_express.png" alt="Walmart Express">
    </div>
  </section>

  <footer>
    <span>Pago procesado por</span>
    <img src="assets/img/LogotipoOpenpay-01.jpg" alt="Openpay">
    <small>ID de operación: {{ficha.charge_id}}</small>
  </footer>
</main>
